
export default {
  // Navigation
  nav_home: 'Home',
  nav_services: 'Knowledge',
  nav_differentials: 'Differentials',
  nav_about: 'About',
  nav_contact: 'Ask Questions',
  nav_login: 'Login',
  nav_blog: 'Blog',
  nav_calculator: 'Calculator',
  nav_resources: 'Resources',
  nav_cta: 'Explore Content',

  // Blog
  blog: {
    hero: {
      title: 'Knowledge that Generates Value',
      subtitle: 'Insights, practical guides and strategies for immigrants and entrepreneurs seeking fiscal excellence and sustainable growth in the United States.'
    },
    newsletter: {
      title: 'Receive Exclusive Content',
      description: 'Subscribe to our newsletter and receive insights, tax tips and compliance updates directly in your email.',
      placeholder: 'Your best email',
      button: 'Subscribe'
    },
    featured_badge: 'Featured',
    featured_articles: 'Featured Articles',
    all_articles: 'All Articles',
    articles_count: 'articles',
    no_articles_found: 'No articles found',
    search_placeholder: 'Search articles...',
    author_team: 'Valora Core Team'
  },

  // Calculator
  calculator: {
    title: 'Educational Tax Scenario Calculator',
    disclaimer: 'This tool presents simulations based on generic scenarios for educational purposes and does not replace individualized professional analysis.',
    year_label: 'Tax year',
    year_tooltip: 'Choose the tax year. Brackets and deductions vary by year.',
    year_2025: '2025',
    year_2024: '2024',
    legal_notice_title: 'Legal basis & notices',
    legal_notice_text: 'IRC §1, §11, §63, §1401–§1402 (SE tax), §3101–§3111 (FICA), §199A (QBI). S‑Corp requires reasonable salary for working shareholders; distributions without salary may be reclassified with retroactive FICA, penalties and interest.',
    form_title: 'Calculation Data',
    entity_type_label: 'Entity Type',
    entity_type_tooltip: 'How you are taxed: Individual/LLC (self-employed), S‑Corp (requires reasonable salary) or C‑Corp (corporate tax and possible dividend tax).',
    entity_pf: 'Individual / Self-Employed',
    entity_llc: 'LLC (disregarded/partnership default)',
    entity_scorp: 'S‑Corp',
    entity_ccorp: 'C‑Corp',
    filing_status_label: 'Filing Status',
    filing_status_tooltip: 'Defines income tax brackets and additional Medicare threshold according to status.',
    filing_single: 'Single',
    filing_mfj: 'Married Filing Jointly',
    filing_mfs: 'Married Filing Separately',
    filing_hoh: 'Head of Household',
    gross_income_label: 'Annual Gross Income',
    gross_income_tooltip: 'Total revenue before deductible expenses. For individuals: self-employment income. For business: total revenue.',
    expenses_label: 'Deductible Expenses',
    expenses_tooltip: 'Business-related expenses that reduce taxable income.',
    other_w2_label: 'Other W-2 Income',
    other_w2_tooltip: 'Salary from employment or other W-2 sources. Affects Social Security limits.',
    reasonable_salary_label: 'Reasonable Salary',
    reasonable_salary_tooltip: 'For S-Corp and C-Corp: minimum fair salary for working shareholder. IRS requires it to be "reasonable" for the role.',
    payout_ratio_label: 'Distribution Ratio',
    payout_ratio_tooltip: 'Percentage of after-tax corporate profit distributed as dividends.',
    qualified_dividends_label: 'Qualified Dividends',
    qualified_dividends_tooltip: 'Qualified dividends have preferential taxation (0%, 15% or 20%).',
    apply_qbi_label: 'Apply QBI Deduction',
    apply_qbi_tooltip: 'Section 199A allows up to 20% deduction on qualified business income.',
    results_title: 'Results',
    income_tax: 'Income Tax',
    se_tax: 'Self-Employment Tax',
    payroll_taxes: 'Payroll Taxes',
    corp_tax: 'Corporate Tax',
    shareholder_div_tax: 'Dividend Tax',
    qbi_deduction: 'QBI Deduction',
    total_tax: 'Total Taxes',
    effective_rate: 'Effective Rate',
    net_income: 'Net Income',
    waiting_calculation: 'Waiting for data for automatic calculation...',
    additional_note: 'S‑Corp requires reasonable salary for working shareholders. Default LLC is taxed as Individual/partnership. C‑Corp has double taxation (corporate and dividends).'
  },

  // Resources
  resources: {
    items: {
      itin_guide: {
        title: 'Complete ITIN Guide 2024',
        description: 'Detailed step by step to obtain your ITIN, necessary documents and deadlines.'
      },
      llc_checklist: {
        title: 'LLC Opening Checklist',
        description: 'Complete list of documents and steps to open your LLC in the USA.'
      }
    }
  },

  // Hero section
  hero_badge: "Orlando, FL • Nationwide Service",
  hero_title: "Tax Education for Immigrants in the USA",
  hero_subtitle: "Technical, practical content in Portuguese about taxes, compliance and business structures in the United States.",
  hero_description: "Valora Core operates, in this phase, with exclusive focus on technical education and informational clarity.",
  hero_cta_primary: "Explore Content",
  hero_cta_secondary: "Subscribe Newsletter",
  
  // Services section
  services_badge: "EDUCATIONAL CONTENT",
  services_title: "Learn About US Taxation",
  services_subtitle: "Educational content to master taxes, compliance, and business structures in the United States",
  services_read_more: "Read full content",
  
  service_tax_title: "Personal/Corporate Taxes",
  service_tax_subtitle: "Learn about individual and business tax filing in the USA. Understand forms, deadlines and strategies.",
  service_tax_1: "Understand Form 1040 / 1040-NR",
  service_tax_2: "Learn Partnership taxation (1065)",
  service_tax_3: "Discover S-Corporation (1120-S)",
  service_tax_4: "Comprehend C-Corporation (1120)",
  service_tax_5: "How to review previous returns",
  service_tax_6: "Tax planning principles",
  service_tax_7: "Understanding QBI Deduction (IRC §199A)",
  
  service_company_title: "Business Formation",
  service_company_subtitle: "Understand business structures and learn to make informed decisions about your business.",
  service_company_1: "Differences between LLC, C-Corp and S-Corp",
  service_company_2: "Understand Operating Agreements",
  service_company_3: "Learn about EIN and BOI Report (FinCEN)",
  service_company_4: "Discover tax classification strategies",
  service_company_5: "Understand tax planning concepts",
  service_company_6: "Business compliance principles",
  
  service_itin_title: "ITIN",
  service_itin_subtitle: "Understand the ITIN application process and legal requirements in the USA.",
  service_itin_1: "Understand the complete ITIN process",
  service_itin_2: "Learn about ITIN renewal",
  service_itin_3: "Know the role of CAA",
  service_itin_4: "Understand deadlines and tracking",
  service_itin_5: "Required documentation and requirements",
  service_itin_6: "Certified Acceptance Agent (CAA)",
  
  service_compliance_title: "Compliance",
  service_compliance_subtitle: "Learn about legal obligations and keep your company always in compliance.",
  service_compliance_1: "Understand state annual reports",
  service_compliance_2: "Comprehend BOI Report (FinCEN)",
  service_compliance_3: "Learn about obligations calendar",
  service_compliance_4: "Principles of continuous monitoring",
  service_compliance_5: "Know IRS and FinCEN compliance",
  service_compliance_6: "How to prevent fines and penalties",
  
  service_accounting_title: "Business Financial Management",
  service_accounting_subtitle: "Learn about accounting organization and financial control for small businesses.",
  service_accounting_1: "Bank reconciliation principles",
  service_accounting_2: "Transaction categorization",
  service_accounting_3: "Understanding management reports",
  service_accounting_4: "How to create efficient tax calendar",
  service_accounting_5: "Tax categorization techniques",
  service_accounting_6: "Financial report interpretation",
  
  service_credits_title: "Tax Credits and Deductions (Individual)",
  service_credits_subtitle: "Learn to identify legally allowed credits and deductions and understand how they directly impact tax owed or refund amount.",
  service_credits_1: "Difference between deductions, non-refundable and refundable credits",
  service_credits_2: "EITC - Earned Income Tax Credit (operation and eligibility)",
  service_credits_3: "Child Tax Credit (CTC) and Additional Child Tax Credit",
  service_credits_4: "Credit for Other Dependents (concepts and application)",
  service_credits_5: "Standard deduction vs. itemized deductions (when to use each)",
  service_credits_6: "Medical, educational and work expenses (when applicable)",
  service_credits_7: "Eligibility principles, income limits and common mistakes",
  service_credits_8: "How to avoid rejections, audits and IRS adjustments",
  

  lang_portuguese: "Português",
  lang_spanish: "Español",
  lang_english: "English",

  // Important Info section
  info_badge: "IMPORTANT INFORMATION",
  info_title: "Stay informed about your rights and obligations",
  info_subtitle: "Essential information for Brazilians in the USA",
  info_card_1_title: "Left Brazil? Complete your Tax Exit and avoid problems with the Brazilian IRS.",
  info_card_1_description: "If you moved to the USA and still file taxes in Brazil, you might be paying more than you should. Learn how to regularize your situation and avoid fines.",
  info_card_2_title: "If you're a student in the USA, Form 8843 is mandatory!",
  info_card_2_description: "Even without income, F-1, F-2, J-1, and M-1 students must file Form 8843 with the IRS every year. Ignoring this document can affect your future status.",
  info_card_3_title: "Need to file taxes but don't have an SSN? You need an ITIN.",
  info_card_3_description: "The ITIN is the IRS tax number for those without Social Security. With it, you can file taxes, open bank accounts, and build financial history in the USA.",

  // Client Portal
  client_dashboard: "Dashboard",
  client_documents: "Documents",
  client_messages: "Messages",
  client_invoices: "Invoices",
  client_welcome: "Welcome back",
  client_services_status: "Services Status",
  client_pending_documents: "Pending Documents",
  client_upcoming_deadlines: "Upcoming Deadlines",
  client_recent_activity: "Recent Activity",
  client_upload_document: "Upload Document",
  client_view_all: "View All",
  client_send_message: "Send Message",
  client_new_message: "New Message",
  client_pay_now: "Pay Now",
  client_download: "Download",
  client_status_in_progress: "In Progress",
  client_status_completed: "Completed",
  client_status_pending: "Pending",
  client_logout: "Logout",
  client_collapse_menu: 'Collapse menu',
  client_expand_menu: 'Expand menu',

  // About section
  about_badge: "WHY EDUCATION",
  about_title: "Why do we prioritize education?",
  about_intro: "Valora Core offers technical education and specialized content on taxes and compliance for immigrants, based in Orlando (FL) and serving throughout the United States.",
  about_description_1: "Valora Core believes that conscious tax decisions depend on technical understanding. Therefore, we choose to consolidate our authority through education before expanding our operational activities, establishing a solid foundation of trust.",
  about_description_2: "Our commitment is to reduce the tax and regulatory information asymmetry faced by immigrants in the USA, providing accurate, analytical and pedagogical content in Portuguese.",
  about_mission_intro: "Guiding principle:",
  about_mission: "Education precedes operation. Authority precedes scale.",
  about_certification_title: "Specialist in Accounting for Immigrants",
  about_certification_desc: "Certified and registered to serve clients in all American states",
  about_languages_title: "2 Languages",
  about_languages_list: "PT • ES • EN",
  
  // Stats
  about_stat_clients_number: "500+",
  about_stat_clients_label: "Clients Served",
  about_stat_satisfaction_number: "98%",
  about_stat_satisfaction_label: "Satisfaction",
  about_stat_experience_number: "5+",
  about_stat_experience_label: "Years of Experience",
  about_stat_support_number: "24/7",
  about_stat_support_label: "Support",
  
  // Client types
  about_clients_title: "Our Clients",
  about_clients_subtitle: "We serve different profiles with personalized solutions for each need",
  
  about_client_immigrants_title: "Immigrants",
  about_client_immigrants_subtitle: "Tax peace of mind for those who started over in the USA.",
  about_client_immigrants_description: "Complete support in Portuguese and Spanish for tax regularization and growth.",
  
  about_client_freelancers_title: "Freelancers",
  about_client_freelancers_subtitle: "We simplify your accounting so you can focus on growing.",
  about_client_freelancers_description: "Tax returns, ITIN, tax planning and personalized business structuring.",
  
  about_client_small_business_title: "Small Businesses",
  about_client_small_business_subtitle: "From opening to expansion, we take care of the entire structure.",
  about_client_small_business_description: "LLC, S-Corp, C-Corp, compliance, monthly accounting and strategic consulting.",
  
  about_client_entrepreneurs_title: "New Entrepreneurs",
  about_client_entrepreneurs_subtitle: "Open your business the right way, without complications.",
  about_client_entrepreneurs_description: "Complete guidance from structuring to the first year of operation.",

  // Footer section
  footer_description: "Tax and fiscal education specialized for Brazilians in the USA.",
  footer_services_title: "Educational Resources",
  footer_company_title: "Company",
  footer_contact_title: "Ask Questions",
  footer_about_us: "About Us",
  footer_differentials: "Differentials",
  footer_contact: "Contact",
  footer_blog: "Blog",
  footer_location: "Orlando, FL\nUnited States",
  footer_copyright: `© ${new Date().getFullYear()} Valora Core. All rights reserved.`,
  footer_privacy_policy: "Privacy Policy",
  footer_terms_of_use: "Terms of Use",
  footer_powered_by: "Powered by Conexdev Solutions",

  // Differentials section
  differentials_badge: "OUR APPROACH",
  differentials_title: "Why learn with Valora Core?",
  differentials_subtitle: "More than tax content, we teach practical strategies for immigrants to master their finances in the USA",
  
  differential_compliance_title: "Preventive Education",
  differential_compliance_description: "We teach you to do it right from day one.",
  differential_compliance_details: "Our focus is teaching how to prevent tax problems before they happen, empowering you to navigate the American system with confidence.",
  
  differential_communication_title: "Didactic and Clear",
  differential_communication_description: "We teach in your language — literally.",
  differential_communication_details: "We explain each concept clearly, without complicated terms, so you learn and master the process.",
  
  differential_specialization_title: "Immigration Specialization",
  differential_specialization_description: "We understand the challenges of starting from scratch.",
  differential_specialization_details: "We teach about the entire American tax and accounting structure, considering documentation, deadlines and specific challenges of those living outside Brazil.",
  
  differential_digital_title: "Practical Learning",
  differential_digital_description: "Content accessible from anywhere in the USA.",
  differential_digital_details: "Combination of digital content and practical examples, the way Brazilians need to master American taxation.",

  // FAQ section
  faq_title: "Frequently Asked Questions",
  faq_subtitle: "Clarify your doubts about American taxation. Didn't find the answer? Send your question!",
  faq_cta_title: "Need more information?",
  faq_cta_subtitle: "Explore our educational content or send your specific question about taxation!",
  faq_cta_speak: "Explore Content",
  faq_cta_email: "Send Email",

  // FAQ ITIN
  faq_itin_category: "ITIN",
  faq_itin_q1: "What is ITIN and who needs it?",
  faq_itin_a1: "ITIN (Individual Taxpayer Identification Number) is a tax identification number issued by the IRS for people who need to file taxes in the USA but are not eligible for SSN. It's necessary for non-residents with income in the USA, dependents of citizens/residents, and spouses of Americans.",
  faq_itin_q2: "How long does it take to get the ITIN?",
  faq_itin_a2: "The complete process takes between 7 to 11 weeks after the IRS receives your application. With Valora Core, we prepare all documentation in 3-5 business days and follow the entire process until approval.",
  faq_itin_q3: "What documents are needed?",
  faq_itin_a3: "You will need: valid passport (original or certified copy), completed W-7 form, tax return (if applicable), and documents proving ITIN necessity. Our team guides you through each step.",

  // FAQ Business Formation
  faq_business_category: "Business Formation",
  faq_business_q1: "LLC or S-Corp: which to choose?",
  faq_business_a1: "LLC is ideal for small businesses and freelancers, offering flexibility and personal protection. S-Corp is better for companies with profit above $60k/year, allowing savings on payroll taxes. We do free analysis of your case to recommend the best structure.",
  faq_business_q2: "How much does it cost to open an LLC?",
  faq_business_a2: "Costs vary by state. In Florida, for example, the state fee is $125 + our fees of $499 (complete package including EIN, Operating Agreement, and consulting). We offer customized packages for each need.",
  faq_business_q3: "Can I open a company without SSN?",
  faq_business_a3: "Yes! You can open LLC/S-Corp using ITIN or even without tax number initially. We help non-residents and foreigners structure companies in the USA in a 100% legal and compliant way.",

  // FAQ additional categories
  faq_taxes_category: "Taxes",
  faq_taxes_q1: "What are the important tax deadlines?",
  faq_taxes_a1: "Individual (1040): April 15. LLC/Partnership (1065): March 15. S-Corp (1120-S): March 15. C-Corp (1120): April 15. Quarterly estimated taxes: Apr 15, Jun 15, Sep 15, Jan 15. We send automatic reminders for all deadlines.",
  faq_taxes_q2: "What is BOI Report (FinCEN)?",
  faq_taxes_a2: "BOI (Beneficial Ownership Information) is a mandatory report since 2024 for most companies in the USA, informing who the real owners are. Companies created before 2024 have until Dec 31, 2024 to report. Non-compliance penalty: up to $10,000. We handle the entire process for you.",
  faq_taxes_q3: "Can I deduct home office expenses?",
  faq_taxes_a3: "Yes! You can deduct a percentage of rent, internet, utilities, and maintenance proportional to the space used exclusively for work. Also deductible: equipment, software, business travel, and much more. We legally maximize your deductions.",

  faq_services_category: "Services",
  faq_services_q1: "Do you serve throughout the USA?",
  faq_services_a1: "Yes! Our physical office is in Orlando, FL, but we serve clients in all 50 states through consultations, email, and phone. We offer comprehensive services with the same quality as in-person service.",
  faq_services_q2: "How does the free first consultation work?",
  faq_services_a2: "Schedule a 30-minute video call with our specialists. We'll understand your situation, answer your questions, and present a personalized plan with no commitment. We serve in Portuguese and Spanish.",
  faq_services_q3: "What payment methods do you accept?",
  faq_services_a3: "We accept credit/debit cards (Visa, Mastercard, Amex), bank transfers (ACH), Zelle, PayPal, and installment payments up to 3x interest-free for services above $500. We issue receipts and invoices for all transactions.",

  // CTA section
  cta_title: "Transform Knowledge into Tax Security",
  cta_subtitle: "Learning is the first step. Mastering American taxation is the next.",
  cta_description: "At Valora Core, every tax concept transforms into confidence to make informed decisions.",
  cta_feature_1: "Practical and applied content",
  cta_feature_2: "Personalized learning",
  cta_feature_3: "Sustainable knowledge",
  cta_button: "Explore Articles",
  cta_footer: "Free and accessible content • No commitment • Available nationally",

  // WhatsApp component
  whatsapp_number: "16897774321",
  whatsapp_comment: "Valora Core WhatsApp number (replace with real number)",
  whatsapp_business_title: "💼 Open Company in USA",
  whatsapp_business_message: "Hello! I'd like to know more about opening a company in the USA (LLC/S-Corp).",
  whatsapp_itin_title: "🆔 Request ITIN",
  whatsapp_itin_message: "Hello! I need help obtaining my ITIN (Individual Taxpayer Identification Number).",
  whatsapp_taxes_title: "📊 Tax Return",
  whatsapp_taxes_message: "Hello! I'd like information about tax returns in the USA.",
  whatsapp_boi_title: "📋 BOI Report",
  whatsapp_boi_message: "Hello! I need help with the BOI Report (Beneficial Ownership Information).",
  whatsapp_other_title: "💬 Other Subject",
  whatsapp_other_message: "Hello! I'd like to speak with a Valora Core specialist.",
  whatsapp_button_title: "Ask Questions",
  whatsapp_button_subtitle: "Choose a subject:",
  whatsapp_close: "Close",

  // Newsletter
  newsletter_title: "Educational Newsletter",
  newsletter_description: "Receive weekly updates on compliance, taxes and tax planning for immigrants",
  newsletter_placeholder: "Your best email",
  newsletter_button: "Subscribe",
  newsletter_disclaimer: "Free content. No spam. Cancel anytime.",

  // Blog categories
  categories: {
    all: 'All',
    impostos: 'Taxes',
    abertura_empresa: 'Company Formation',
    compliance: 'Compliance',
    planejamento_tributario: 'Tax Planning',
    gestao_financiera: 'Financial Management',
    empreendedorismo: 'Entrepreneurship'
  },

  // Blog post interface
  blog_post: {
    you_will_learn: 'In this article you will learn:',
    fundamental_concepts: 'Fundamental concepts about the topic',
    practical_steps: 'Practical and applicable step-by-step',
    expert_tips: 'Tips from Valora Core experts',
    avoid_errors: 'How to avoid common errors',
    why_important: 'Why This is Important?',
    importance_description: 'For immigrants and entrepreneurs in the United States, understanding tax and regulatory nuances is fundamental for business success and sustainable growth. Lack of knowledge can result in penalties, fines, and missed tax savings opportunities.',
    valora_tip: 'Valora Core Tip',
    tip_description: 'Always keep your documentation organized and updated. This facilitates not only compliance with tax obligations but also allows identifying tax optimization opportunities throughout the year.',
    main_points: 'Main Points of Attention',
    points_description: 'When dealing with tax and accounting matters in the United States, it is essential to pay attention to various aspects that can significantly impact your tax situation:',
    deadlines: 'Deadlines established by the IRS and state agencies',
    documentation: 'Required documentation and specific requirements',
    deductions: 'Tax deduction and credit opportunities',
    compliance_regulations: 'Compliance and adherence to current regulations',
    how_we_help: 'How Valora Core Can Help',
    help_description: 'Our team of experts is prepared to offer complete support at all stages of the process. With service in Portuguese and Spanish, we ensure you fully understand each aspect of your tax situation and make informed decisions for your business growth.',
    need_help: 'Have a technical question about this topic?',
    schedule_consultation: 'Leave your comment or subscribe to our newsletter to receive weekly compliance updates.',
    contact_specialist: 'Subscribe Newsletter',
    conclusion: 'Conclusion',
    conclusion_description: 'Understanding and properly managing your tax obligations is fundamental for your business success in the United States. With adequate support and specialized knowledge, you can transform compliance into competitive advantage and focus on what really matters: sustainable growth of your company.',
    tags: 'TAGS',
    share: 'SHARE',
    related_articles: 'Related Articles'
  },

  // Cookie Consent
  cookie_title: 'We Use Cookies',
  cookie_description: 'We use cookies to enhance your browsing experience, provide personalized content, analyze traffic, and improve our services. Some cookies are essential for the website to function properly.',
  cookie_settings: 'Cookie Settings',
  cookie_accept_all: 'Accept All',
  cookie_reject: 'Reject Optional',
  cookie_reject_all: 'Reject All',
  cookie_save_preferences: 'Save Preferences',
  cookie_settings_title: 'Cookie Preferences',
  cookie_settings_description: 'We use different types of cookies for various purposes. You can customize your preferences below. Please note that disabling some cookies may affect website functionality.',
  cookie_always_active: 'Always Active',
  
  cookie_necessary_title: 'Necessary Cookies',
  cookie_necessary_description: 'These cookies are essential for the website to function and cannot be disabled. They are usually set in response to actions you take, such as language preferences, login or form submissions.',
  
  cookie_analytics_title: 'Analytics Cookies',
  cookie_analytics_description: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve the user experience.',
  
  cookie_marketing_title: 'Marketing Cookies',
  cookie_marketing_description: 'These cookies are used to provide you with relevant advertisements and marketing communications. They may be used to build a profile of your interests and show you relevant ads.',
  
  cookie_functional_title: 'Functional Cookies',
  cookie_functional_description: 'These cookies enable enhanced functionality and personalization, such as videos and live chats. They may be set by us or third-party providers.',

  // Privacy Policy
  privacy_policy_title: 'Privacy Policy',
  privacy_policy_last_updated: 'Last updated',
  privacy_policy_introduction_title: 'Introduction',
  privacy_policy_introduction_text: 'Valora Core LLC ("we," "our," or "us") is an accounting firm specialized in immigrants, based in Orlando, FL with operations throughout the United States. We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our accounting and tax services.',
  privacy_policy_collection_title: 'Information We Collect',
  privacy_policy_personal_info: 'Personal Information',
  privacy_policy_personal_info_1: 'Name, email address, phone number, and mailing address',
  privacy_policy_personal_info_2: 'Tax identification numbers (SSN, ITIN, EIN) and business information',
  privacy_policy_personal_info_3: 'Financial information for tax preparation and business formation services',
  privacy_policy_personal_info_4: 'Immigration status, family composition, and dependent information for tax purposes',
  privacy_policy_usage_data: 'Usage Data',
  privacy_policy_usage_data_1: 'IP address, browser type, and device information',
  privacy_policy_usage_data_2: 'Pages visited, time spent, and interaction patterns',
  privacy_policy_usage_data_3: 'Referral sources and search terms',
  privacy_policy_usage_data_4: 'Cookies and similar tracking technologies',
  privacy_policy_cookies_title: 'Cookies and Tracking Technologies',
  privacy_policy_cookies_description: 'We use cookies and similar technologies to enhance your experience, analyze usage, and provide personalized content. You can manage your cookie preferences through our cookie consent banner.',
  privacy_policy_cookie_types: 'Types of Cookies We Use',
  privacy_policy_necessary_cookies: 'Essential for website functionality and security',
  privacy_policy_analytics_cookies: 'Help us understand user behavior and improve our services',
  privacy_policy_marketing_cookies: 'Used for targeted advertising and marketing campaigns',
  privacy_policy_functional_cookies: 'Enable enhanced features like live chat and videos',
  privacy_policy_usage_title: 'How We Use Your Information',
  privacy_policy_usage_1: 'Provide and maintain our accounting, tax preparation, and business consulting services',
  privacy_policy_usage_2: 'Process tax returns, ITIN applications, and business formation documents',
  privacy_policy_usage_3: 'Communicate with you about our services, deadlines, and regulatory updates',
  privacy_policy_usage_4: 'Improve our website and services based on usage analytics and client feedback',
  privacy_policy_usage_5: 'Comply with IRS, FinCEN, and other regulatory requirements',
  privacy_policy_usage_6: 'Protect against fraud and ensure platform security for sensitive financial data',
  privacy_policy_sharing_title: 'Information Sharing and Disclosure',
  privacy_policy_sharing_description: 'We do not sell, trade, or rent your personal information. We may share information only in the following circumstances:',
  privacy_policy_sharing_1: 'With your explicit consent or at your direction',
  privacy_policy_sharing_2: 'With trusted service providers who assist our operations',
  privacy_policy_sharing_3: 'To comply with legal obligations or court orders',
  privacy_policy_sharing_4: 'To protect our rights, property, or safety and that of our users',
  privacy_policy_security_title: 'Data Security',
  privacy_policy_security_description: 'We implement industry-standard security measures to protect your information, including encryption, secure servers, and regular security audits. However, no method of transmission over the internet is 100% secure.',
  privacy_policy_rights_title: 'Your Privacy Rights',
  privacy_policy_rights_1: 'Access and review your personal information',
  privacy_policy_rights_2: 'Request correction of inaccurate or incomplete data',
  privacy_policy_rights_3: 'Request deletion of your personal information',
  privacy_policy_rights_4: 'Object to or restrict certain processing activities',
  privacy_policy_rights_5: 'Request data portability in a structured format',
  privacy_policy_rights_6: 'Withdraw consent for optional data processing',
  privacy_policy_transfers_title: 'International Data Transfers',
  privacy_policy_transfers_description: 'As we serve clients internationally, your information may be transferred to and processed in countries other than your residence. We ensure appropriate safeguards are in place for such transfers.',
  privacy_policy_retention_title: 'Data Retention',
  privacy_policy_retention_description: 'We retain your information only as long as necessary to provide our services, comply with legal obligations, or resolve disputes. Tax-related documents may be retained for extended periods as required by law.',
  privacy_policy_contact_title: 'Contact Us',
  privacy_policy_contact_description: 'If you have questions about this Privacy Policy or wish to exercise your privacy rights, please contact us:',
  privacy_policy_updates_title: 'Policy Updates',
  privacy_policy_updates_description: 'We may update this Privacy Policy periodically. We will notify you of significant changes through our website or direct communication. Your continued use of our services constitutes acceptance of the updated policy.',
  contact_email: 'Email',
  contact_address: 'Address',
  contact_phone: 'Phone',
  all_rights_reserved: 'All rights reserved.'
};
